var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NotificationMessage',{attrs:{"avatar":_vm.message.avatar,"text":'It\'s been 48 hours since you\'ve accepted the rental request and ' + _vm.message.customerName + ' still hasn\'t payed. The rental request has been cancelled.'}})}
var staticRenderFns = []

export { render, staticRenderFns }